/**
 * @generated SignedSource<<f3c6f08a10c9575fc72f8d019d72869c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateMailingListSubscriptionReasonInput = {
  de: string;
  en: string;
  id: string;
};
export type EditSubscriptionReasonDialogMutation$variables = {
  input: UpdateMailingListSubscriptionReasonInput;
};
export type EditSubscriptionReasonDialogMutation$data = {
  readonly updateMailingListSubscriptionReason: {
    readonly id: string;
    readonly subscriptionReason: {
      readonly de: string | null | undefined;
      readonly en: string | null | undefined;
    } | null | undefined;
  };
};
export type EditSubscriptionReasonDialogMutation = {
  response: EditSubscriptionReasonDialogMutation$data;
  variables: EditSubscriptionReasonDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MailingList",
    "kind": "LinkedField",
    "name": "updateMailingListSubscriptionReason",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Label",
        "kind": "LinkedField",
        "name": "subscriptionReason",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "de",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "en",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditSubscriptionReasonDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditSubscriptionReasonDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "000c9d870543c03059e0e2bf585491bc",
    "id": null,
    "metadata": {},
    "name": "EditSubscriptionReasonDialogMutation",
    "operationKind": "mutation",
    "text": "mutation EditSubscriptionReasonDialogMutation(\n  $input: UpdateMailingListSubscriptionReasonInput!\n) {\n  updateMailingListSubscriptionReason(input: $input) {\n    id\n    subscriptionReason {\n      de\n      en\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3b452b649c3f835ae52bbd529edc8031";

export default node;
